import React, {useMemo} from 'react'
import {useRouteMatch} from 'react-router'
import {Redirect, Route, Switch} from 'react-router-dom'
import {Box, Center, Flex, Skeleton} from '@chakra-ui/react'
import SUBROUTES from './subroutes'
import {MyStokkeRootPathProvider} from './hooks/use-root-path'
import {removeSiteLocaleFromPath, removeTrailingSlash} from '../../utils/url'
import {useInitialDataLayer} from '../../tracking/hooks/use-initial-data-layer'
import {useCustomerId} from '@salesforce/commerce-sdk-react'
import {isServer} from '../../utils/utils'
import MyStokkeGuardedRoute from './partials/guarded-route'
import SkeletonText from '../../components/skeleton-text'
import {HeaderVariant} from '../../leap/components/navigation/header/header-variant'

const MyStokke = () => {
    const customerId = useCustomerId()
    // this is the route match from the parent route
    const {path} = useRouteMatch()
    const rootPath = useMemo(() => removeTrailingSlash(removeSiteLocaleFromPath(path)), [path])

    useInitialDataLayer({pageType: 'My Stokke'})

    if (!customerId || isServer) {
        return (
            <>
                {/* Matches the page's own background.section.subtle content bg (STOK-17418) */}
                <HeaderVariant bg="background.section.subtle" />
                <Box bgColor="background.section.subtle">
                    <SkeletonText
                        skeletonHeight={1}
                        width={32}
                        mb={4}
                        mt={4}
                        ml={4}
                        noOfLines={1}
                    />
                    <Center width="90%" margin="auto">
                        <SkeletonText width={64} skeletonHeight={2} noOfLines={1} />
                    </Center>
                    <Skeleton width="95%" height="75vh" margin="20px auto" />
                </Box>
            </>
        )
    }

    return (
        <MyStokkeRootPathProvider value={rootPath}>
            <HeaderVariant bg="background.section.subtle" />
            <Flex flexDirection="column" data-testid="my-stokke-page">
                <Switch>
                    {SUBROUTES.map(({path: subpath, exact, ...routeConfig}, idx) => (
                        <Route key={idx} exact={exact} path={path + subpath}>
                            <MyStokkeGuardedRoute routeConfig={routeConfig} />
                        </Route>
                    ))}
                    {/* default fallback to redirect back to dashboard */}
                    <Route>
                        <Redirect to={path} />
                    </Route>
                </Switch>
            </Flex>
        </MyStokkeRootPathProvider>
    )
}

export default MyStokke
